import BaseApiRequest from "./BaseApiRequest";
import { GET_PASSWORD_CRITERIA_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetPasswordCriteriaRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(GET_PASSWORD_CRITERIA_URL);

  getBody = () => this.body;
}
